import apiClient from './apiClient';

// Re-export the unified axios instance for backward compatibility with modules/tests
const api = apiClient.getClient();
export default api;
